
import { Component, createRef } from "react";
import App from "../../App";

import "./gameplay.scss";
import "./personnage.scss";


import { IGameplayManagerProps } from "./IGameplayManagerProps";
import { TGameplayManagerState } from './TGameplayManagerState';


import { DirectionLitterale, CodeQuestions } from '../../interfaces/ILabyData';
import { getDirectionsAllowed, getIndexFromObjPosition, getLabyDataFromId, getRelativePosition, labyMatricToArray, obtenirCaseVoisine, objPosition, getEmptyLabyMatrice, trouverCoffreDomByCode2 } from './GameplayUtils';
import GameManager from '../GameManager/GameManager';

import img_personnage from "../../images/personnage.svg";
import { renderTuilesDebugMouvement, logTuilesDebugMouvement, renderTuilesDebugDeclencheur, renderTuilesDebugQuestion, logTuilesDebugDeclencheurs, logTuilesDebugQuestions } from './EditeurHelpers';
import TuileTorche from "./TuileTorche/TuileTorche";
import TuileCoffre from "./TuileCoffre/TuileCoffre";

const labyBackgrounds = [
  require("../../images/labyrinthes/niveau_1.png"),
  require("../../images/labyrinthes/niveau_2.png"),
  require("../../images/labyrinthes/niveau_3.png"),
  require("../../images/labyrinthes/niveau_4.png"),
  require("../../images/labyrinthes/niveau_5.png")
]

class GameplayManager extends Component<IGameplayManagerProps,any> {

  public app:App;
  gameManager:GameManager;

  
  labyrintheDOM = createRef<HTMLDivElement>();
  wrapperLabDOM = createRef<HTMLDivElement>();
  jeuLabDOM = createRef<HTMLDivElement>();
  public coffresDOM = createRef<HTMLDivElement>();
  public tuilesDebugMouvDOM = createRef<HTMLDivElement>();
  public tuilesDebugDeclDOM = createRef<HTMLDivElement>();
  public tuilesDebugQuestDOM = createRef<HTMLDivElement>();
  personnageDOM = createRef<HTMLImageElement>();

  timeoutPartieTerminee:any = null;
  
  constructor(props:any){
    super(props);
    this.app = props.app;
    this.gameManager = props.gameManager;
  }

  state:TGameplayManagerState = this.getInitialState();
  getInitialState():TGameplayManagerState{
    return{
      isActive:false,
      variante:0,
      controlLocked:true,
      partieTerminee:false,
      positionPersonnage:{ligne:"A", colonne:0},
      currentMatriceDeplacement:[],
      currentMatriceTorches:[],
      currentMatriceDeclencheurs:[],
      currentMatriceQuestions:[],
      currentMatriceQuestionsVisibles:[]
    }
  }
  
  componentDidMount(){   
    const curLabyData = getLabyDataFromId(this.props.niveau, this.app.donneesLaby);
    const nombreDeVariantesLaby = curLabyData.matrices_questions.length;
    const varianteAuHasard = Math.floor(Math.random() * nombreDeVariantesLaby);
    
    const matriceDeplacement = labyMatricToArray(curLabyData.matrice_deplacement);
    const matriceTorches = labyMatricToArray(curLabyData.matrice_torches);
    const matriceDeclencheurs = labyMatricToArray(curLabyData.matrices_questions[varianteAuHasard].matrice_declencheurs);
    const matriceQuestions = labyMatricToArray(curLabyData.matrices_questions[varianteAuHasard].matrice_questions);
    const matriceQuestionsVisibles = labyMatricToArray(getEmptyLabyMatrice());
    const startingPositionPersonnage = {ligne:"J", colonne:7};
 
    this.setState(
      {
        isActive:true,
        variante:varianteAuHasard,
        controlLocked:false,
        positionPersonnage:startingPositionPersonnage,
        currentMatriceDeplacement:matriceDeplacement,
        currentMatriceTorches:matriceTorches,
        currentMatriceDeclencheurs:matriceDeclencheurs,
        currentMatriceQuestions:matriceQuestions,
        currentMatriceQuestionsVisibles:matriceQuestionsVisibles
      }
    );    
    window.addEventListener('keydown', this.handleKeydownEvent);    
    this.refreshDirectionsPermises(this.state.positionPersonnage);
    setTimeout(()=>{this.centrerSurPersonnage()}, 100);
  }
  componentWillUnmount(){      
    this.setState(
      {
        isActive:false,
        controlLocked:true
      }
    );    
    window.removeEventListener('keydown', this.handleKeydownEvent);
  }

  componentDidUpdate(){      
    
  }
  
  public init(){
    
  }
  
  refreshDirectionsPermises(objDir:objPosition){
    const directionsPermises = getDirectionsAllowed(objDir, this.state.currentMatriceDeplacement);
    this.gameManager.setDirectionsPermises(directionsPermises);

  }

  handleKeydownEvent = (event:KeyboardEvent) => {
    if (this.gameManager.state.game_active && !this.gameManager.state.popup_ouvert){
      const { key } = event;
      switch(key){
        case "ArrowLeft": event.preventDefault(); this.handleClickFlecheHud("GAUCHE") ; break;
        case "ArrowUp": event.preventDefault(); this.handleClickFlecheHud("HAUT") ; break;
        case "ArrowDown": event.preventDefault(); this.handleClickFlecheHud("BAS") ; break;
        case "ArrowRight": event.preventDefault(); this.handleClickFlecheHud("DROITE") ; break;
        case "m": logTuilesDebugMouvement(this); break;
        case "d": logTuilesDebugDeclencheurs(this); break;
        case "q": logTuilesDebugQuestions(this); break;
        case "t": getIndexFromObjPosition(this.state.positionPersonnage); break;        
        case "y": console.log(getDirectionsAllowed(this.state.positionPersonnage, this.state.currentMatriceDeplacement)); break;
      }
    }
  }


  centrerSurPersonnage(){
    const relativePosition = getRelativePosition(this.personnageDOM.current, this.wrapperLabDOM.current);
    const demiLargeurEcran = (this.labyrintheDOM.current) ? (this.labyrintheDOM.current.getBoundingClientRect().width / 2) : 0;
    const demiHauteurEcran = (this.labyrintheDOM.current) ? (this.labyrintheDOM.current.getBoundingClientRect().height / 2) : 0;

    this.labyrintheDOM.current?.scrollTo({
      left: relativePosition.left - demiLargeurEcran,
      top: relativePosition.top - demiHauteurEcran,
      behavior:"smooth"
    });
  }

  public handleClickFlecheHud(dir:DirectionLitterale){
    if (this.state.controlLocked || this.state.partieTerminee) return;
    
    const nextCase = obtenirCaseVoisine(this.state.positionPersonnage, dir);
    const directionAllowed = getDirectionsAllowed(this.state.positionPersonnage, this.state.currentMatriceDeplacement);
    if (nextCase && directionAllowed.indexOf(dir) >-1){
      const curIndexNextCase = getIndexFromObjPosition(nextCase);
      const nextMoveCaseCode = this.state.currentMatriceDeplacement[curIndexNextCase];
      const nextDeclencheurCaseCode = this.state.currentMatriceDeclencheurs[curIndexNextCase];
      const nextQuestionVisibleCaseCode = this.state.currentMatriceQuestionsVisibles[curIndexNextCase];
      // const controllsWillLock 
      var objStateUpdate:any = {
        positionPersonnage:nextCase
      };
      if (nextDeclencheurCaseCode !== "0"){
        // Supprimer le déclencheur en question
        const newDeclencheurArray = [...this.state.currentMatriceDeclencheurs];
        newDeclencheurArray[curIndexNextCase] = "0";
        objStateUpdate.currentMatriceDeclencheurs = newDeclencheurArray;
        // Ajouter la question au array des questions visibles
        const newQuestionsVisiblesArray = [...this.state.currentMatriceQuestionsVisibles];
        newQuestionsVisiblesArray[this.state.currentMatriceQuestions.indexOf(nextDeclencheurCaseCode)] = nextDeclencheurCaseCode as CodeQuestions;
        objStateUpdate.currentMatriceQuestionsVisibles = newQuestionsVisiblesArray;
        this.gameManager.updateCoffreHudStatus(nextDeclencheurCaseCode as CodeQuestions, "active");        
        this.app.audioManager.current?.play("coffre_apparait");
      } else if (nextMoveCaseCode === "F"){
        objStateUpdate.partieTerminee = true;        
        this.app.audioManager.current?.play("escaliers");
        this.timeoutPartieTerminee = setTimeout(() => {
          this.gameManager.ouvrirFinPartie();
        }, 2500);
      }
      
      if (nextQuestionVisibleCaseCode !== "0"){
        const coffreDom = trouverCoffreDomByCode2(this.coffresDOM.current, nextQuestionVisibleCaseCode);

        if (coffreDom){
          const valeurCoffre = parseInt(coffreDom.getAttribute("data-valeur") as string);
          this.gameManager.ouvrirQuestion(nextQuestionVisibleCaseCode as CodeQuestions, valeurCoffre);
          this.retirerCoffreCode(nextQuestionVisibleCaseCode as CodeQuestions);
        }
      }
      this.setState(objStateUpdate);      
      this.refreshDirectionsPermises(nextCase);
    }
    
    setTimeout(()=>{this.centrerSurPersonnage()}, 200);
  }

  public retirerCoffreCode(code:CodeQuestions){
    const newCoffreArray = [...this.state.currentMatriceQuestionsVisibles];
    const indexCoffre = newCoffreArray.indexOf(code);
    newCoffreArray[indexCoffre] = "0";
    this.setState({currentMatriceQuestionsVisibles:newCoffreArray});
  }


  getPersoClasses(){
    const curPos = this.state.positionPersonnage;
    const pTerminee = (this.state.partieTerminee) ? "persoPartieTerminee" : "";
    return `perso_sprite_pos_x_${curPos.colonne} perso_sprite_pos_y_${curPos.ligne} ${pTerminee}`;
  }  

  renderTuilesTorches = () => {    
    const matriceTorches = this.state.currentMatriceTorches;
    return (
        <>
        {
            
            matriceTorches.map((item,index)=>{
            return (item === "1" &&
            <TuileTorche 
                index={index}
                key={`tuile_torche_n_${this.props.niveau}_${index}`}
                />
            )
        })
        
        }
        </>
    )
  }

  renderTuilesCoffres = () => {    
    const matriceCoffres = this.state.currentMatriceQuestionsVisibles;
    return (
        <>
        {
            
            matriceCoffres.map((item,index)=>{
            return (item !== "0" &&
            <TuileCoffre 
                gpl_manager={this}
                index={index}
                codeQuestion={item as CodeQuestions}
                key={`tuile_coffre_n_${this.props.niveau}_${index}`}
                />
            )
        })
        
        }
        </>
    )
  }

  render() {    
    return (
        <div className="labyrinthe" ref={this.labyrintheDOM}>
          <div className="debug">{ this.state.variante }</div>
          <div className="wrapper-lab" ref={this.wrapperLabDOM}>
            <div className="jeu_laby" ref={this.jeuLabDOM}>
              <img src={labyBackgrounds[this.props.niveau-1]} alt="Labyrinthe" onClick={() => {this.centrerSurPersonnage()}} />
              <div className="jeu_torches">
                { this.renderTuilesTorches() }
              </div>
              <div className="jeu_coffres" ref={this.coffresDOM}>
                { this.renderTuilesCoffres() }
              </div>
              <div className="jeu_declencheurs" />
              <div className="jeu_tuiles_mouv" ref={this.tuilesDebugMouvDOM}>
                { renderTuilesDebugMouvement(this) }
              </div>
              <div className="jeu_tuiles_decl" ref={this.tuilesDebugDeclDOM}>
                { renderTuilesDebugDeclencheur(this) }
              </div>
              <div className="jeu_tuiles_quest" ref={this.tuilesDebugQuestDOM}>
                { renderTuilesDebugQuestion(this) }
              </div>
              <div className="jeu_personnage">
                  <img
                    src={img_personnage}
                    ref={this.personnageDOM}
                    className={this.getPersoClasses()}
                    alt="personnage"
                  />
              </div>
            </div>
          </div>
        </div>
    )
  }

  
 
  
}

export default GameplayManager;
